import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import * as XLSX from "xlsx";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { v4 as uuidv4 } from "uuid";
import { armarPlantillaOC, leerExcelOC } from "./plantillaOC";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

// nacional = true: "OC Nacional" (menu Compras). Se crea la OC ya embarcada con su embarque nacional
// (POST /ordenesCompraNacional) y se recibe en Recepciones; la cuenta por pagar nace al recibir.
function OrdenesCompraCreate({ nacional = false }) {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [moneda, setMoneda] = useState("");

  const [fecha, setFecha] = useState(hoy);
  const [plazo, setPlazo] = useState("0");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  // La OC normal es de importacion; la nacional tiene su propia tarjeta (OC Nacional)
  const tipo = nacional ? "Nacional" : "Internacional";
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  // Kasher (con factura) / Taref (sin factura): pasa al embarque y a la cuenta por pagar
  const [kasher, setKasher] = useState("Taref");
  // IVA opcional solo en la OC nacional (el proveedor extranjero no cobra IVA); total_general = subtotal
  const [aplicaIVA, setAplicaIVA] = useState("No");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [totalCaptura, setTotalCaptura] = useState(1);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      articulosNombre: null,
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const ivaOC = nacional && aplicaIVA === "Si" ? Number((total_general * 0.16).toFixed(2)) : 0;
  const fmtTotal = (v) => "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
  const textoTotales = `TOTALES ${total_cantidad} pzas. / ${
    ivaOC ? `${fmtTotal(total_general)} + IVA ${fmtTotal(ivaOC)} = ${fmtTotal(total_general + ivaOC)}` : fmtTotal(total_general)
  }`;

  // OC Nacional: un solo endpoint crea OC + embarque nacional + renglones (se recibe en Recepciones)
  const saveOrdenCompraNacional = async () => {
    const renglones = inputFields.filter((a) => a.articulos != "" && parseFloat(a.cantidad) > 0);
    if (!selectedProveedor || selectedProveedor === "0") {
      Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el proveedor" });
      return;
    }
    if (renglones.length == 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Captura al menos un articulo con cantidad" });
      return;
    }
    setValidaBoton(false);
    toggleProgreso();
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      const { data } = await axios.post(
        `${URL_ORDENES_COMPRA}Nacional`,
        {
          fecha,
          moneda,
          proveedores: selectedProveedor,
          plazo: parseFloat(plazo),
          fecha_compromiso,
          observaciones,
          total_general: parseFloat(total_general),
          total_cantidad: parseFloat(total_cantidad),
          fechaEmbarque: fecha,
          fechaEstimada: fecha_compromiso,
          user: user.id,
          kasher,
          aplicaIVA: ivaOC ? "Si" : "No",
          iva: ivaOC,
          articulos: renglones.map((a) => ({
            articulos: a.articulos,
            cantidad: parseFloat(a.cantidad),
            precio: parseFloat(a.precio),
            total: parseFloat(a.total),
          })),
        },
        { headers }
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Orden de Compra Nacional",
          detalle: `OC ${data.idOrdenCompra} / Embarque ${data.idEmbarques} / ${selectedProveedor} ${total_general}`,
          user: user.id,
        },
        { headers }
      );
      Swal.fire({
        icon: "success",
        title: "Good job!",
        html: `OC Nacional #${data.idOrdenCompra} creada (embarque #${data.idEmbarques}).<br>Recíbela en <b>Compras → Recepciones</b>.`,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    } catch (error) {
      setModalProgreso(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se guardo la OC",
        footer: `${error?.response?.data?.message || error.message}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  const saveOrdenCompra = async (event) => {
    event.preventDefault();

    if (nacional) {
      return saveOrdenCompraNacional();
    }

    setValidaBoton(false);
    toggleProgreso();

    let totalArticulos = inputFields.length;

    try {
      await axios
        .post(
          URL_ORDENES_COMPRA,
          {
            fecha,
            proveedores: selectedProveedor,
            plazo,
            fecha_compromiso,
            total_general,
            total_cantidad,
            observaciones,
            embarcado: 0,
            moneda,
            tipo,
            user: user.id,
            kasher,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            axios
              .post(
                URL_ARTICULOS_OC,
                {
                  ordenesCompra: data.data._id,
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  embarcado: 0,
                  pendiente_embarcar: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Orden de Compra",
                        detalle: `${selectedProveedor} ${total_general}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                });
                console.log(error);
                setValidaBoton(true);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    }
  };
  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        articulosNombre: ultimo.articulosNombre || null,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(parseFloat(TG.toFixed(2)));
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        // redondeo a 2 decimales: cantidad * precio arrastra basura de punto flotante
        let totalParcial = parseFloat(i.cantidad) * parseFloat(i.precio);
        i.total = isNaN(totalParcial) ? 0 : parseFloat(totalParcial.toFixed(2));
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Precio sugerido de un master (no tiene costo propio): el de la variante a la que entra al recibir,
  // por unidad base (misma regla que el back: la que comparte su SKU, la unica o la mas chica)
  const costoDe = (a) => Number(moneda == "USD" ? a.costoUSD : a.costoMX) || 0;
  const precioSugerido = (m) => {
    if (m.modelo !== "MASTER") return costoDe(m);
    const hijos = articulos.filter(
      (h) => String(h.articuloPadre) === String(m._id) && h.modelo !== "MASTER" && h.is_active !== "No"
    );
    if (!hijos.length) return costoDe(m);
    const mismo = hijos.find((h) => String(h.SKU).toUpperCase() === String(m.SKU).toUpperCase());
    if (mismo) return costoDe(mismo);
    if (hijos.length === 1) return costoDe(hijos[0]);
    const chica = hijos.reduce((x, y) => ((Number(y.piezasPorCaja) || 1) < (Number(x.piezasPorCaja) || 1) ? y : x));
    return Number((costoDe(chica) / (Number(chica.piezasPorCaja) || 1)).toFixed(4));
  };

  function BuscaArticulo(id, selectedArticulo) {
    if (!selectedArticulo) return;
    handleChangeInputArticulo(id, selectedArticulo._id, precioSugerido(selectedArticulo), selectedArticulo);
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB, opcion) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.articulosNombre = opcion || null;
        i.total = 0;
        i.precio = FOB;
        i.cantidad = 0;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(parseFloat(TG.toFixed(2)));
  }

  function jalaProveedor(e) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: null,
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ])
    setSelectedProveedor(e);
    proveedores.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }

  // La OC se captura por MASTER: al recibir (Recepciones) cada master entra a su variante (la que
  // comparte su SKU o la unica; con varias presentaciones, a la mas chica en unidades base)
  // Un master sin variantes (recien dado de alta) tambien sale: al recibirlo se le crea su variante unica
  const conVariantes = new Set(
    articulos.filter((h) => h.articuloPadre && h.modelo !== "MASTER" && h.is_active !== "No").map((h) => String(h.articuloPadre))
  );
  const options = articulos
    .filter((a) => a.modelo === "MASTER" && a.is_active !== "No")
    .map((option) => {
      const junta = (option.SKU || "") + (option.nombre || "");
      const firstLetter = ((option.SKU || "X")[0] || "X").toUpperCase();
      return {
        firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
        ...option,
        junta,
      };
    });

  // ---- Carga masiva de renglones desde Excel (plantilla: SKU, CANTIDAD, PRECIO) ----
  const descargarPlantillaOC = () => {
    XLSX.writeFile(armarPlantillaOC(), "Plantilla Orden de Compra.xlsx");
  };

  const importarExcelOC = (event) => {
    const archivo = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!archivo) return;
    if (!selectedProveedor || selectedProveedor === "0") {
      Swal.fire({
        icon: "warning",
        title: "Primero elige el proveedor",
        text: "El precio por default depende de la moneda del proveedor.",
      });
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const wb = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
      const { error, renglones, noEncontrados, invalidos } = leerExcelOC(wb, articulos, moneda, precioSugerido, { soloMasters: true });
      if (error) {
        Swal.fire({ icon: "error", title: "Archivo no válido", text: error });
        return;
      }
      const lista = (titulo, items) =>
        items.length
          ? `<p style="text-align:left;margin:8px 0 0"><b>${titulo} (${items.length})</b><br/>${items
              .slice(0, 25)
              .join("<br/>")}${items.length > 25 ? "<br/>..." : ""}</p>`
          : "";
      if (!renglones.length) {
        Swal.fire({
          icon: "warning",
          title: "No se cargó ningún renglón",
          html: lista("SKU no encontrados", noEncontrados) + lista("Renglones con datos inválidos", invalidos),
        });
        return;
      }

      // Se agregan a lo ya capturado (el renglon vacio inicial se descarta)
      const nuevos = renglones.map((r) => ({ id: uuidv4(), ...r }));
      const todos = [...inputFields.filter((r) => r.articulos !== "" && r.articulos != null), ...nuevos];
      setInputFields(todos);
      setTotalCantidad(todos.reduce((t, r) => t + (parseFloat(r.cantidad) || 0), 0));
      setTotalGeneral(parseFloat(todos.reduce((t, r) => t + (parseFloat(r.total) || 0), 0).toFixed(2)));

      const piezas = nuevos.reduce((t, r) => t + r.cantidad, 0);
      const importe = nuevos.reduce((t, r) => t + r.total, 0);
      Swal.fire({
        icon: noEncontrados.length || invalidos.length ? "warning" : "success",
        title: `${nuevos.length} renglones cargados`,
        html:
          `${new Intl.NumberFormat("en-US").format(piezas)} pzas · $${new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(importe)}<br/>Revísalos antes de guardar.` +
          lista("SKU no encontrados (no se cargaron)", noEncontrados) +
          lista("Renglones con datos inválidos (no se cargaron)", invalidos),
      });
    };
    reader.readAsArrayBuffer(archivo);
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_oc ? (
        <div className="card container col-12">
          <h3 align="center">{nacional ? "Nueva Orden de Compra Nacional" : "Nueva Orden de Compra"}</h3>
          {nacional && (
            <p
              style={{
                fontSize: "0.8rem",
                color: "#0369a1",
                background: "#f0f9ff",
                border: "1px solid #bae6fd",
                borderRadius: 6,
                padding: "6px 10px",
              }}
            >
              <i className="fas fa-info-circle" /> Al guardar se crea la OC con su embarque nacional y queda en{" "}
              <b>Compras → Recepciones</b> para recibirla. La cuenta por pagar al proveedor se genera al recibir, por lo que
              realmente llegue.
            </p>
          )}
          <Form onSubmit={saveOrdenCompra}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    jalaProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial} {a.moneda}</option>;
                    })}
                </Input>
              </Col>
              {/* <Col md={3}>
                <Label>Plazo</Label>
                <Input
                  type="text"
                  placeholder="Plazo"
                  value={plazo}
                  required
                  onChange={(e) => {
                    setPlazo(e.target.value);
                  }}
                />
              </Col> */}
              <Col md={3}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="Fecha Compromiso"
                  value={fecha_compromiso}
                  required
                  onChange={(e) => {
                    setFechaCompromiso(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Kasher / Taref</Label>
                <Input type="select" value={kasher} onChange={(e) => setKasher(e.target.value)}>
                  <option value="Kasher">Kasher (con factura)</option>
                  <option value="Taref">Taref (sin factura)</option>
                </Input>
              </Col>
            </Row>
            <Row>
              {nacional && (
                <Col md={2} style={{ display: "flex", alignItems: "center" }}>
                  <Label check style={{ marginLeft: 20 }}>
                    <Input
                      type="checkbox"
                      checked={aplicaIVA === "Si"}
                      onChange={(e) => setAplicaIVA(e.currentTarget.checked ? "Si" : "No")}
                    />
                    Lleva IVA (16%)
                  </Label>
                </Col>
              )}
              <Col md={nacional ? 8 : 10}>
                <h4 id="logoutBoton">{textoTotales}</h4>
              </Col>
            </Row>
<br />
            <Row style={{ marginBottom: 10, alignItems: "flex-end" }}>
              <Col md={3}>
                <Button size="sm" color="success" onClick={descargarPlantillaOC}>
                  <i className="fas fa-file-excel"></i> Descargar plantilla
                </Button>
              </Col>
              <Col md={5}>
                <Label style={{ fontSize: "0.8rem", color: "#64748b", marginBottom: 2 }}>
                  Cargar renglones desde Excel (SKU, CANTIDAD, PRECIO)
                </Label>
                <Input type="file" accept=".xlsx,.xls" onChange={importarExcelOC} />
              </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={5}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio {moneda}</Label>
              </Col>
              
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={5}>
                    <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta || ""}
                      getOptionSelected={(option, value) => option._id === value._id}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {!conVariantes.has(String(option._id)) && (
                            <span
                              title="Al recibirlo se le crea su variante única (mismo SKU)"
                              style={{
                                background: "#fef3c7",
                                color: "#92400e",
                                fontSize: "0.65rem",
                                padding: "2px 6px",
                                borderRadius: 4,
                                marginRight: 6,
                              }}
                            >
                              sin variantes
                            </span>
                          )}
                          {option.articuloPadre && (
                            <span
                              style={{
                                background: "#e2e8f0",
                                color: "#64748b",
                                fontSize: "0.65rem",
                                padding: "2px 6px",
                                borderRadius: 4,
                                marginRight: 6,
                              }}
                            >
                              variante
                            </span>
                          )}
                          {option.SKU} {option.nombre}
                        </React.Fragment>
                      )}
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={inputField.precio}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
            <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <h4 id="logoutBoton">{textoTotales}</h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoOrdenesCompra"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCompraCreate;
